import {ComponentProps} from 'react';
import {
  TabGroup as HeadlessTabGroup,
  TabGroupProps,
  TabList as HeadlessTabList,
  TabListProps,
  TabPanel as HeadlessTabPanel,
  TabPanelProps,
  TabPanels as HeadlessTabPanels,
} from '@headlessui/react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {TrackedTab} from '@/components/tracked-atoms/tracked-tab';

export const TabGroup = ({className, ...props}: TabGroupProps) => (
  <HeadlessTabGroup className={twMerge(clsx('mt-3 w-full', className))} {...props} />
);

export const TabList = ({className, ...props}: TabListProps) => (
  <HeadlessTabList
    className={twMerge(
      clsx(
        'mb-8 flex w-full items-center justify-between gap-6 rounded-2 bg-purple-100 p-1 font-medium text-charcoal',
        className,
      ),
    )}
    {...props}
  />
);

export const TabPanel = ({className, ...props}: TabPanelProps) => (
  <HeadlessTabPanel
    className={twMerge(
      clsx(
        'w-full rounded-2 px-6 py-3 text-base transition-colors hover:bg-purple-200 focus:bg-purple-200 data-[selected]:bg-white data-[selected]:text-violet',
        className,
      ),
    )}
    {...props}
  />
);

export const Tab = ({className, ...props}: ComponentProps<typeof TrackedTab>) => (
  <TrackedTab
    className={twMerge(
      clsx(
        'w-full rounded-2 px-6 py-3 text-base transition-colors',
        'hover:bg-purple-200',
        'focus:bg-purple-200',
        'disabled:grayscale',
        'data-[selected]:bg-white data-[selected]:text-violet',
        className,
      ),
    )}
    {...props}
  />
);

export {HeadlessTabPanels as TabPanels};
